import React from "react";
import { useState, useEffect } from "react";
import { format, parseISO } from "date-fns";
import parse from 'html-react-parser';

import '../content/base_2.0.css';
import '../content/ccbh-tableau-portal_2.0.css';
import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";
import './firstTimeLogin.css';

import { postUpdatedAccountInfo} from "../helpers/tableauAccountHelpers";
import { getUser } from "../helpers/tableauUserHelpers";
import { addStat } from "../helpers/statHelpers";

import {BeatLoader} from "react-spinners";

import { formatPhone } from "../scripts/ccbh";

export const UserEditAccountModal = ({closeModal, user }) => {
    const [loading, setLoading] = useState(true);
    const spinnerCSS = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        zAxis: 999,
     };

    const [selectedUser, setSelectedUser] = useState();
    const [selectUserWebuserId, setSelectedUserWebuserId] = useState('');
    const [selectedUserFirstName, setUserFirstName] = useState('');
    const [selectedUserLastName, setUserLastName] = useState('');
    const [selectedUserEmail, setUserEmail] = useState('');
    const [selectedUserPhone, setUserPhone] = useState('');
    const [selectUserLastLogin, setSelectedUserLastLogin] = useState('');
    const [selectUserRole, setSelectedUserRole] = useState('');
    const [passwordErrorMsg, setPasswordErrorMsg] = useState('');
    const [mode, setMode] = useState('Edit');
    const [saveButtonDisabled, setSaveButtonDisabled] = useState("disabled");

    const handleFirstNameChange = event =>{
        setUserFirstName(event.target.value);
        enableUpdateAccount();
    };
    const handleLastNameChange = event => {
        setUserLastName(event.target.value);
        enableUpdateAccount();
    };
    const handleEmailChange = event => {
        setUserEmail(event.target.value);
        enableUpdateAccount();
    };
    const handlePhoneChange = (event) => {
        setUserPhone(event.target.value);
        enableUpdateAccount();
        
        if(event.keyCode !==46 && event.keyCode !== 8){
            phoneFormat();
        }
    };
    
    function phoneFormat(){
        formatPhone(document.getElementById("user-phone"));
    };

    function enableUpdateAccount() {
        if(validateUserInfo()){
            setSaveButtonDisabled('');
        }else{
            setSaveButtonDisabled("disabled");
        }
    };

    const updateAccountInfo = async event => {
        var response;
        var dlgSuccessMessage;
        var dlgErrorMessage;
        var dlgUsername;
        
        console.log('update account info', selectedUser.webuserId);
        dlgSuccessMessage = "Account Information Updated";
        dlgErrorMessage = "Problem Updating Account Information, try again!";
        dlgUsername = document.getElementById('user-username').defaultValue;

        response = await postUpdatedAccountInfo(document.getElementById('user-username').defaultValue,
                            selectedUserFirstName, 
                            selectedUserLastName,
                            selectedUserEmail,
                            selectedUserPhone,
                            selectUserRole,
                            '',
                            selectedUser.webuserId,
                            true);
    
        console.log('update 2: ', response);
            
        if(response === 1 || response.value.errorCode === 0){
            setSaveButtonDisabled(true);
            
            ccbhmessagebox({
                message: dlgSuccessMessage,
                title: "User Account Information",
                modal: true,
                closebutton: false,
                buttons: {
                    'Ok': function () {
                            addStat(selectedUser.webuserId, 'Edit Account', 'Saved: ' + dlgUsername);
                            removeMsg();
                            closeModal(selectedUser);
                    }
                }
            });
        }else{
            ccbhmessagebox({
                message: dlgErrorMessage,
                title: "User Account Information",
                modal: true,
                closebutton: false,
                buttons: {
                    'Ok': function () {
                            removeMsg();
                    }
                }
            });
        }
    };

    function validateUserInfo() {
        const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/g;
        const isValidPhone = /^((((\+[\d\-.]{1,5})?[ \-.]?\d{3})|(\+[\d\-.]{1,5})?[ \-.]?\((\d{3}\)))?[ \-.]?\d{3}[ \-.]?\d{4}\s?(e?x?t?\.?\s?\d{1,7})?)?$/i

        var errorText = ''
        if(document.getElementById('user-firstname').value === ''){
            errorText = "Must Enter User First Name <br />";
        }
        if(document.getElementById('user-lastname').value === ''){
            errorText += "Must Enter User Last Name <br />";
        }
        if((document.getElementById('email').value === '') || (!document.getElementById('email').value.match(isValidEmail))){
            errorText += "Must Enter A Valid User Email Address <br />";
        }

        var phone = document.getElementById('user-phone').value;
        if(phone !== ''){
            var phoneNum = phone.replace(/[^\d]/g, '');
            if(phoneNum.length < 10  || !(phoneNum.match(isValidPhone))) {  
                errorText += "Phone Number Is Not a Valid Format";  
            }
        }else{
            errorText += "Phone Number Is Not a Valid Format";  
        }

        document.getElementById('email-error').innerHTML = errorText;

        return (errorText === '');
    };

    const cancelModal = () => {
        closeModal();
        let addEditusername = '';
        if (selectUserWebuserId !== undefined){
            addEditusername = selectUserWebuserId;
        }
        addStat(user.webuserId, 'Edit User', 'Canceled: ' + addEditusername);
    };

    const fetchUser = async(username) => {
        return await getUser(username.webuserId).then(
            r => { 
                setSelectedUser(r);
                setSelectedUserWebuserId(r.webuserId);
                setUserFirstName(r.firstName);
                setUserLastName(r.lastName);
                setUserEmail(r.email);
                setUserPhone(r.phoneNumber);
                setSelectedUserLastLogin(format(parseISO(r.lastLoginDate), "MMM d, yyyy"));

                return r;
            }
        );
    };

    useEffect(() => {
        fetchUser(user);
        setPasswordErrorMsg('');
        //addStat(user.webuserId, 'Edit User',selectUserWebuserId);

        if(user.lastLoginDate !== null && user.lastLoginDate !== undefined){
            setSelectedUserLastLogin(format(parseISO(user.lastLoginDate), "MMM d, yyyy"));
        }   

        setLoading(false);
        }, 
    [2]);


    return(
        <>
        <div className="modal-container-userEdit">
            <div className="modal-userEdit">
            <div id="">
                <h6>{selectedUserFirstName} {selectedUserLastName} Account Information</h6>
            </div>
            <div id="login_loader">
                <BeatLoader 
                    color="#762d6a"
                    loading={loading}
                    size={25}
                    aria-label="Logging In"
                    data-testid="loader"
                    cssOverride={spinnerCSS}
                />
            </div>
            <div className="account-info-row">
                <input className="settings-text-input css-13cymwt-control" type="text" id="user-username" name="user-username" defaultValue={selectUserWebuserId} disabled />
                <label className="settings-label">Username</label>
            </div>

            <div className="account-info-row">
                    <input className="settings-text-input css-13cymwt-control" type="text" id="user-firstname" name="user-firstname" defaultValue={selectedUserFirstName} onChange={handleFirstNameChange}  required />
                    <label className="settings-label">First Name</label>
                    <br />
                    
                    <input className="settings-text-input css-13cymwt-control" type="text" id="user-lastname" name="user-lastname" defaultValue={selectedUserLastName} onChange={handleLastNameChange}  required />
                    <label className="settings-label" id="user-lastname">Last Name</label>
                    <br />
                    
                    <input className="settings-text-input css-13cymwt-control" type="email" id="email" name="email" title="Enter a valid email address" x-moz-errormessage="Please enter a valid email address" defaultValue={selectedUserEmail} onChange={handleEmailChange}  required />
                    <label className="settings-label">Email</label>
                    <br />
                    
                    <input className="settings-text-input css-13cymwt-control" type="tel" id="user-phone" name="phone" title="Format:(123)446-7890" x-moz-errormessage="Format:(123)446-7890" defaultValue={selectedUserPhone} onKeyDown={handlePhoneChange} placeholder="Format:(123)446-7890"  required />
                    <label className="settings-label" id="user-phone">Phone Number</label>
                    <br />
                                                                                
                    <span id="email-error-span"><label className="warning" id="email-error">{parse(passwordErrorMsg)}</label></span>
                    <span id="phone-error-span"><label className="warning" id="phone-error"></label></span>
            </div>
            
            <div className="account-info-row">
                <input className="settings-text-input css-13cymwt-control" type="text" id="user-lastlogin" title="user last login time" disabled defaultValue={selectUserLastLogin} />
                <label className="settings-label" id="last-login">Last Login Date</label>
                <br />
            </div>
        
            <div className="shadow-talk" id="edit-account-info">
                <div id="settings-button-row">
                    <input type="button" id="user_update_account_info" name="user_update_account_info" onClick={updateAccountInfo}  value="Save" disabled={saveButtonDisabled} /> 
                    <input type="button" id="close-modal" name="close_user_update_modal" onClick={cancelModal} value="Cancel" />
                </div>
            </div> {/* <!-- setting form wrapper --> */}

        </div>
        </div>    
        </>
    );
};

